<script setup>
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";

defineProps({
    resource: {
        type: Object,
        required: true,
    },
});

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const borderColorClass = computed(() => {
    return portalContentAndDesignStore.getPageContentTextColorClass
        .replace('text-', 'border-')
        .replace('custom-content-text', 'gray-200') + ' border-opacity-20';
});
</script>

<template>
    <div>
        <hr :class="['border-t', borderColorClass]" />
    </div>
</template>
